import { createFileRoute } from "@tanstack/react-router";
import { pageMeta } from "@/lib/seo";

export const Route = createFileRoute("/refund-policy")({
  head: () =>
    pageMeta({
      path: "/refund-policy",
      title: "Política de reembolso — Truck Company Center",
      description:
        "Política de reembolso de Truck Company Center: cuándo aplica un reembolso y qué conceptos no son reembolsables.",
    }),
  component: RefundPage,
});

function RefundPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 md:px-6">
      <h1 className="font-display text-3xl font-semibold text-foreground md:text-4xl">Política de reembolso</h1>
      <div className="mt-8 space-y-5 text-sm leading-relaxed text-muted-foreground">
        <p>Truck Company Center es la marca comercial bajo la que operamos.</p>
        <p>Nuestros servicios son principalmente administrativos y personalizados. Una vez que el cliente realiza el pago, comenzamos a revisar información, organizar el proceso, preparar documentos y/o iniciar solicitudes según el servicio comprado.</p>
        <p>Los reembolsos pueden aprobarse únicamente si el cliente solicita la cancelación antes de que hayamos iniciado trabajo administrativo, preparación de documentos, envío de solicitudes, coordinación con terceros o uso de fees oficiales.</p>
        <p className="font-medium text-foreground">No son reembolsables:</p>
        <ul className="ml-5 list-disc space-y-1.5">
          <li>fees oficiales ya enviados o utilizados;</li>
          <li>solicitudes ya presentadas;</li>
          <li>servicios ya iniciados;</li>
          <li>documentos ya preparados;</li>
          <li>diseños ya entregados;</li>
          <li>tiempo administrativo ya trabajado;</li>
          <li>pagos relacionados con terceros, proveedores, plataformas, impresión, ropa, bordado, envío, seguros o suscripciones externas.</li>
        </ul>
        <p>Si un servicio no puede completarse por información incorrecta, falta de respuesta del cliente, rechazo de una entidad externa o requisitos de terceros, eso no garantiza reembolso automático.</p>
        <p>Si corresponde un reembolso parcial, se descontará el trabajo ya realizado, fees oficiales, cargos de terceros y costos administrativos aplicables.</p>
        <p>Para solicitar revisión de reembolso, el cliente debe contactarnos por email o WhatsApp con su nombre, email usado en el pedido, número de pedido y explicación del caso.</p>
        <p>Los pagos procesados por Stripe pueden tardar varios días hábiles en reflejarse como reembolso según el banco o tarjeta del cliente.</p>
        <p className="pt-4 text-xs text-muted-foreground">Última actualización: 2026.</p>
      </div>
    </div>
  );
}
